import { render, staticRenderFns } from "./SkeletonShimmer.vue?vue&type=template&id=506c8ec7&scoped=true&"
import script from "./SkeletonShimmer.vue?vue&type=script&lang=ts&"
export * from "./SkeletonShimmer.vue?vue&type=script&lang=ts&"
import style0 from "./SkeletonShimmer.vue?vue&type=style&index=0&id=506c8ec7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506c8ec7",
  null
  
)

export default component.exports